module.exports = __webpack_public_path__ + "img/default-image.29e298d9.jpeg";